import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://timechainstats.com';
const BRAND = 'TimechainStats';

// Per-route title base + description. Title is prefixed with the live price at render.
const ROUTE_META = {
  '/': {
    title: 'Live Bitcoin Price & Network Stats',
    description: 'Track the live Bitcoin price and real-time network data. Free dashboard with hashrate, difficulty, mempool, mining, and market metrics. No ads, no sign-up.',
  },
  '/network': {
    title: 'Bitcoin Network Stats',
    description: 'Real-time Bitcoin network statistics: hashrate, difficulty, mempool status, node count, and live block data.',
  },
  '/mining': {
    title: 'Bitcoin Mining Stats',
    description: 'Live Bitcoin mining data: pool distribution, block rewards, subsidy, and fee analysis updated in real time.',
  },
  '/market': {
    title: 'Bitcoin Market Data',
    description: 'Bitcoin market data: live price, trade volume, market cap, and circulating supply metrics in one dashboard.',
  },
  '/charts': {
    title: 'Bitcoin Charts',
    description: 'Historical Bitcoin charts covering price, hashrate, fees, and block sizes spanning up to three years.',
  },
  '/resources': {
    title: 'Bitcoin Resources & Glossary',
    description: 'Curated Bitcoin educational resources, glossary, and reference material for learning about the timechain.',
  },
  '/stonks': {
    title: 'Bitcoin vs Stocks, Gold & Assets',
    description: 'Compare Bitcoin against traditional assets, stocks, gold, and key economic indicators in real time.',
  },
  '/calculator': {
    title: 'Bitcoin & Sats Calculator',
    description: 'Convert Bitcoin and satoshis across 20 fiat currencies with the free TimechainStats calculator.',
  },
  '/papertrader': {
    title: 'Bitcoin Paper Trading Calculator',
    description: 'Model Bitcoin trades and positions with the TimechainStats paper trading calculator.',
  },
  '/custom': {
    title: 'Custom Bitcoin Dashboard Builder',
    description: 'Build your own Bitcoin dashboard. Pick from 48+ live metrics with drag-and-drop customization.',
  },
  '/donate': {
    title: 'Donate',
    description: 'Support TimechainStats, a free real-time Bitcoin dashboard with no ads and no registration.',
  },
};

const DEFAULT_META = ROUTE_META['/'];

export const RouteSEO = ({ bitcoinPrice }) => {
  const { pathname } = useLocation();
  const meta = ROUTE_META[pathname] || DEFAULT_META;

  const priceLabel = bitcoinPrice
    ? `$${Math.round(parseFloat(bitcoinPrice)).toLocaleString('en-US')}`
    : null;

  const title = priceLabel
    ? `${priceLabel} | ${meta.title}`
    : `${meta.title} | ${BRAND}`;

  const canonical = pathname === '/' ? SITE_URL : `${SITE_URL}${pathname}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
};

RouteSEO.propTypes = {
  bitcoinPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
